<template>
  <div class="d-flex  fill-height flex-column">
    <ActionBar
        class="pa-3 pr-5"
        border-bottom
        :disabled="isLocked"
        show-save
        @save="saveChanges"
        show-add
        @add="dialog = true"
        show-import
        :disabled-import="schematisationStagesToImport.length === 0"
        @import="toggleImportDialog(true)"
    />
    <div class="d-flex flex-column overflow-y-auto">
      <div class="fill-height overflow-y-auto ma-0">
        <div v-if="!topoProfilePointItems.length" class="pa-3 pb-0">
          <v-alert  variant="outlined" type="warning" density="compact">
            Please note there is no topo profile available, therefore the
            loads cannot be visualized.
          </v-alert>
        </div>
        <NoDataAvailableCenter v-if="!uniformLoadItems.length && !treeLoadItems.length"></NoDataAvailableCenter>
        <UniformLoads />
        <TreeLoads/>
      </div>
    </div>
<!--    TODO this still needs to be solved-->
    <LoadsDialog v-model="dialog"></LoadsDialog>
    <ImportFromPreviousStageDialog
        :schematisation-stages="schematisationStagesToImport"
        :model-value="importDialog"
        :loading="importLoading"
        text="loads"
        @close="toggleImportDialog(false)"
        @import="handleImport"
    />
  </div>

</template>
<script>
import {mapActions, mapGetters, mapState} from "vuex";
import LoadsDialog from '@/components/loads/LoadsDialog.vue';
import TreeLoads from '@/components/loads/TreeLoads.vue';
import UniformLoads from '@/components/loads/UniformLoads.vue';
import ImportFromPreviousStageDialog from "@/components/schematisationDetail/ImportFromPreviousStageDialog.vue";
import ActionBar from '@/components/common/ActionBar.vue';
import NoDataAvailableCenter from "@/components/soilcomposition/NoDataAvailableCenter.vue"

export default {
  name: 'LoadsData',
  components: {
    NoDataAvailableCenter,
    ActionBar,
    ImportFromPreviousStageDialog,
    UniformLoads,
    TreeLoads,
    LoadsDialog
  },
  data: () => ({
    dialog: false,
  }),
  computed: {
    ...mapState('stabSchematisationStage', {
      currentItemStage: state => state.currentItem,
    }),
    ...mapState('topoProfilePoint', {
      topoProfilePointItems: state => state.items,
    }),
    ...mapState('uniformLoads', {
      uniformLoadItems: state => state.items,
    }),
    ...mapState('treeLoads', {
      treeLoadItems: state => state.items,
    }),
    ...mapState('load', {
      importLoading: state => state.importLoading,
      importDialog: state => state.importDialog,
    }),
    ...mapGetters('topoProfilePoint', {
      getItem: 'getItem',
    }),
    ...mapGetters('stabSchematisation', {
      isLocked: "isLockedCurrent",
    }),
    ...mapGetters('stabSchematisationStage', {
      schematisationStagesToImport: "previousSchematisationStagesHaveLoad"
    }),
  },
  methods: {
    ...mapActions('uniformLoads', {
          updateUniformLoads: "update",
          createUniformLoads: "create",
          emptyDirtyItemsUniformLoads: "emptyDirtyItems",
          emptyDirtyItemsFieldsUniformLoads: "emptyDirtyItemsFields",
          toggleWriteLoadingUniformLoads: "toggleWriteLoading",
        },
    ),
    ...mapActions('treeLoads', {
          updateTreeLoads: "update",
          createTreeLoads: "create",
          emptyDirtyItemsTreeLoads: "emptyDirtyItems",
          emptyDirtyItemsFieldsTreeLoads: "emptyDirtyItemsFields",

          toggleWriteLoadingTreeLoads: "toggleWriteLoading",
        },
    ),
    ...mapActions('load', {
      toggleImportDialog: "toggleImportDialog",
      importLoadsFromStage: "importLoadsFromStage",
    }),
    cleanUpDirtyItems() {
      this.emptyDirtyItemsTreeLoads();
      this.emptyDirtyItemsUniformLoads();
      this.emptyDirtyItemsFieldsUniformLoads();
      this.emptyDirtyItemsFieldsTreeLoads();
    },
    async saveChanges() {
      try {
        await this.updateUniformLoads()
        await this.createUniformLoads()
        await this.updateTreeLoads()
        await this.createTreeLoads()
        this.cleanUpDirtyItems();
      } catch (e) {
        this.toggleWriteLoadingUniformLoads()
        this.toggleWriteLoadingTreeLoads()
      }
    },
    async handleImport(sourceSchematisationStageId) {
      try {
        this.cleanUpDirtyItems();
        await this.importLoadsFromStage({
          sourceSchematisationStageId,
          targetSchematisationStageId: this.currentItemStage.id,
        });
      } catch (e) {
        console.log(e);
      } finally {
        this.toggleImportDialog(false);
      }
    },
  }

}
</script>
